import { render, staticRenderFns } from "./xianchu.vue?vue&type=template&id=585d15a7"
import script from "./xianchu.vue?vue&type=script&lang=ts"
export * from "./xianchu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports